'use strict';

import Model        from '../Model';
import QueryBuilder from '../QueryBuilder';
import ModelQuery   from '../ModelQuery';

export default class Partner extends Model {

    static defaultConnection() {
        return 'partners';
    }

    static fields() {
        return `id, company, type`;
    }

    static scrubRateHourlyPartnerQuery(args) {

        if( ! args.hasOwnProperty('filters') ) {
            args = { filters : args };
        }

        let qb = new QueryBuilder();

        let query = qb.fields(this.fields())
            .connection('scrubRateHourlyReportPartners')
            .args(args)
            .edgesQuery();
        
        return new ModelQuery(this, query.gql(), query.variables())
    } 

    static scrubRateHourlySourceQuery(args) {

        if( ! args.hasOwnProperty('filters') ) {
            args = { filters : args };
        }

        let qb = new QueryBuilder();

        let query = qb.fields(this.fields())
            .connection('scrubRateHourlyReportSources')
            .args(args)
            .edgesQuery();
        
        return new ModelQuery(this, query.gql(), query.variables())
    }
}


// WEBPACK FOOTER //
// ./src/graphql/model/Partner.js